import { useState } from "react";
import { ExternalLink, Link2, Loader2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";

const PORTAL_URL = "https://portal.ifood.com.br/";

/** Passo a passo para a loja autorizar o app do Núcleo e informar o ID. */
export default function ConectarLojaCard({ onConnect, busy, temLoja }) {
  const [merchantId, setMerchantId] = useState("");
  const [label, setLabel] = useState("");
  const [aberto, setAberto] = useState(!temLoja);

  const submit = async (e) => {
    e.preventDefault();
    const ok = await onConnect(merchantId.trim(), label.trim());
    if (ok) { setMerchantId(""); setLabel(""); if (temLoja) setAberto(false); }
  };

  if (temLoja && !aberto) {
    return (
      <div className="text-center">
        <button onClick={() => setAberto(true)} className="text-sm text-muted-foreground hover:text-foreground underline underline-offset-2">
          Conectar outra loja (filial)
        </button>
      </div>
    );
  }

  return (
    <div className="p-5 rounded-xl border bg-card space-y-4">
      <div>
        <h3 className="font-semibold flex items-center gap-2"><Link2 className="w-4 h-4" /> Conectar a loja do iFood</h3>
        <p className="text-xs text-muted-foreground mt-1">
          Você não precisa de Client ID nem Client Secret — a credencial é do Núcleo. Só autorizar o app e informar o ID da loja.
        </p>
      </div>
      <ol className="space-y-3 text-sm">
        <li className="flex gap-3">
          <span className="w-6 h-6 rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center shrink-0">1</span>
          <div>
            Entre no <a href={PORTAL_URL} target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline inline-flex items-center gap-1">Portal do Parceiro iFood <ExternalLink className="w-3 h-3" /></a> com o login da loja.
          </div>
        </li>
        <li className="flex gap-3">
          <span className="w-6 h-6 rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center shrink-0">2</span>
          <div>No menu <b>Aplicativos</b>, procure <b>Nucleo PDV</b> e clique em <b>Permitir</b>. A liberação pode levar até 10 minutos.</div>
        </li>
        <li className="flex gap-3">
          <span className="w-6 h-6 rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center shrink-0">3</span>
          <div>Copie o <b>ID da loja</b> (em Perfil da loja → Dados, ou no fim do endereço do portal) e cole aqui.</div>
        </li>
      </ol>
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
        <Input
          id="ifood-merchant-id"
          placeholder="ID da loja (ex.: d8ccd555-a626-485d-8d32-ff662d82ccf5)"
          value={merchantId}
          onChange={(e) => setMerchantId(e.target.value)}
          className="flex-1 font-mono text-sm"
          autoComplete="off"
        />
        <Input
          id="ifood-merchant-label"
          placeholder="Apelido (opcional)"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          className="sm:w-44"
          autoComplete="off"
        />
        <Button type="submit" disabled={busy === "connect" || merchantId.trim().length < 30} className="bg-red-500 hover:bg-red-600 text-white">
          {busy === "connect" ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Link2 className="w-4 h-4 mr-1" />}
          Conectar
        </Button>
      </form>
      {temLoja && (
        <button onClick={() => setAberto(false)} className="text-xs text-muted-foreground hover:text-foreground">Fechar</button>
      )}
    </div>
  );
}
